import React from 'react';

const shimmerBg =
  'linear-gradient(90deg, rgba(30,41,59,0.5) 0%, rgba(51,65,85,0.5) 50%, rgba(30,41,59,0.5) 100%)';

const KanbanCardSkeleton = () => (
  <div
    style={{
      background: 'var(--dp-bg-card, rgba(15,23,42,0.8))',
      border: '1px solid var(--dp-border-subtle, rgba(71,85,105,0.3))',
      borderRadius: '10px',
      overflow: 'hidden',
    }}
  >
    {/* Thumbnail skeleton */}
    <div
      style={{
        width: '100%',
        aspectRatio: '16/9',
        background: shimmerBg,
        backgroundSize: '200% 100%',
        animation: 'kanban-shimmer 1.5s infinite',
      }}
    />

    {/* Content skeleton */}
    <div style={{ padding: '12px' }}>
      {/* Title */}
      <div
        style={{
          height: '14px',
          width: '80%',
          background: 'var(--dp-border-subtle, rgba(71,85,105,0.3))',
          borderRadius: '4px',
          marginBottom: '8px',
        }}
      />
      {/* Date */}
      <div
        style={{
          height: '10px',
          width: '50%',
          background: 'var(--dp-border-subtle, rgba(71,85,105,0.2))',
          borderRadius: '4px',
          marginBottom: '10px',
        }}
      />
      {/* Progress */}
      <div
        style={{
          height: '4px',
          width: '100%',
          background: 'var(--dp-border-subtle, rgba(71,85,105,0.2))',
          borderRadius: '2px',
          marginBottom: '10px',
        }}
      />
      {/* Checklist dots */}
      <div style={{ display: 'flex', gap: '4px' }}>
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <div
            key={i}
            style={{
              width: '22px',
              height: '22px',
              background: 'var(--dp-border-subtle, rgba(71,85,105,0.2))',
              borderRadius: '4px',
            }}
          />
        ))}
      </div>
    </div>
  </div>
);

export default KanbanCardSkeleton;
